import { createContext, use } from "react";

/** Props a Field hands to the control inside it so its label and error message are associated with it. */
export interface FieldControlProps {
	readonly id: string;
	readonly "aria-describedby"?: string;
	readonly "aria-invalid"?: true;
}

export const FieldContext = createContext<FieldControlProps | null>(null);

/** The id and ARIA props of the surrounding Field, or null when the control is used on its own. */
export function useFieldControl(): FieldControlProps | null {
	return use(FieldContext);
}
